// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[role=dialog] .el-message-box__content .el-form>div[data-v-264d3a59]:last-of-type{text-align:left}[role=dialog] .el-message-box__content .el-form>div[data-v-264d3a59]:last-of-type{margin:0}.input-new-tag[data-v-264d3a59]{width:90px;margin-left:10px;vertical-align:bottom}.footer[data-v-264d3a59]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
